import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-stability',
  templateUrl: './stability.component.html',
  styleUrls: ['./stability.component.scss']
})
export class StabilityComponent {
  constructor(private dialogRef: MatDialogRef<StabilityComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
